import { IMAGES } from '@/assets/images'
import colors from '@/styles/colors'
import { LoadingButton } from '@mui/lab'
import { Box, styled } from '@mui/material'

export const MyBasicInfoContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFF',
  borderRadius: '16px',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid rgba(226, 232, 240, 0.8)',
  // boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04)',

  // overflow: 'hidden',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    border: '1px solid rgba(99, 102, 241, 0.15)',
    // boxShadow: '0 4px 12px rgba(99, 102, 241, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04)',
    // overflow: 'auto',
  },

  '& .cover': {
    display: 'flex',
    width: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: '180px',
    position: 'absolute',
    borderRadius: '16px 16px 0px 0px',
    top: 0,
    left: 0,
    right: 0,
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      '& .cover-camera': {
        opacity: 1,
        transform: 'scale(1.05)',
      },
    },
  },

  '& .closeButton': {
    top: '20px',
    right: '20px',
    position: 'absolute',
    zIndex: 10,
  },

  '& .cover-camera': {
    top: '20px',
    right: '20px',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(16px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    opacity: 0.8,
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      backgroundColor: '#6366f1',
      borderColor: 'rgba(255, 255, 255, 0.2)',
      transform: 'scale(1.1)',
      opacity: 1,
    },
  },

  [theme.breakpoints.down('lg')]: {},

  '& .formFields': {
    '& .MuiOutlinedInput-root': {
      border: '0px transparent',
      borderRadius: '12px',
      height: 48,
      backgroundColor: '#f8fafc',
      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      '&:hover': {
        backgroundColor: '#ffffff',
      },
      '& fieldset': {
        borderColor: 'rgba(226, 232, 240, 0.8)',
        borderRadius: '12px',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(99, 102, 241, 0.3)',
      },
      '&.Mui-focused': {
        backgroundColor: '#ffffff',
        boxShadow: '0 0 0 3px rgba(99, 102, 241, 0.1)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#6366f1',
        borderWidth: '2px',
      },
      '&.Mui-error fieldset': {
        borderColor: '#ef4444',
      },
      '&.Mui-disabled fieldset': {
        borderColor: 'rgba(226, 232, 240, 0.5)',
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: '14px',
      fontWeight: 500,
      color: '#64748b',
      '&.Mui-focused': {
        color: '#6366f1',
        fontWeight: 600,
      },
      '&.Mui-error': {
        color: '#ef4444',
      },
    },
    '& .MuiFormHelperText-root': {
      fontSize: '13px',
      marginLeft: '4px',
      marginTop: '6px',
    },
    '& .MuiInputAdornment-positionEnd': {
      '& .MuiIconButton-root': {
        color: '#64748b',
        '&:hover': {
          color: '#6366f1',
        },
      },
    },
  },
}))

export const MyProfileDetailsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
}))

export const DeleteAccountButton = styled(LoadingButton)(({ theme }) => ({
  color: theme.palette.error.main,
  borderColor: theme.palette.error.main,
  margin: 8,
  backgroundColor: 'white',
}))

export const ProfilePrivacyContent = styled(Box)(({ theme }) => ({
  margin: '24px -24px 0px -24px',
  '& .empty-icon': {
    '& path': {
      strokeWidth: 0.3,
    },
  },
  '& .connections': {
    display: 'flex',
    borderBottom: `1px solid ${colors.lightGrey}`,
    borderTop: `1px solid ${colors.lightGrey}`,
    padding: '0 24px',
    alignItems: 'center',
    backgroundColor: 'white',
    position: 'relative',
    zIndex: 10,
    '& button': {
      color: colors.darkGrey,
      borderRadius: 0,
      fontSize: 13,
      height: 50,
      '&.active': {
        borderBottom: `1px solid ${colors.blue}`,
        color: colors.blue,
      },
      [theme.breakpoints.down('md')]: {
        flex: 1,
      },
    },
  },
  '& .search-bar': {
    zIndex: 10,
    backgroundColor: 'white',
    position: 'relative',
    boxShadow: '0 1px 2px rgba(0,0,0,.1)',
  },
  '& .add-circle': {
    border: `2px solid ${colors.blue}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 12px',
    height: 40,
    borderRadius: 6,
    color: colors.blue,
    boxSizing: 'border-box',
    marginLeft: 12,
    cursor: 'pointer',
  },
  '& .group-menu': {
    backgroundColor: colors.grey,
    padding: '5px 10px',
    width: '100%',
    borderRadius: 4,
    height: 40,
    boxSizing: 'border-box',
  },
}))
